<script setup lang="ts">
import { ref } from 'vue'
import { Data } from '@/stores/data'
import { ElMessage } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue'
import { Utill } from '@/stores/Utill'
import emitter from '@/stores/mitt'
import { HTTP } from '@/network/http'
import { useRouter, useRoute } from 'vue-router';
const logoutVisible = ref(false)
const route = useRoute()


const communityCode = ref('')
const customerCode = ref('')

const isShowResult = ref(false)

init()

function init() {
  HTTP.getWXQrCode()
    .then((res) => {
      console.log(res)
      if (res.code == 200) {
        console.log(res)
        console.log(res.data.community)
        console.log(res.data.customer)
        communityCode.value = res.data.community
        customerCode.value = res.data.customer
        Data.qrCodeList.value = res.data
      }
    })
    .catch((error) => {
      console.error('接口调用出错:', error)
    })
  HTTP.activityInfo()
    .then((res) => {
      console.log(res)
      if (res.code == 200) {
        console.log(res.data)
        Data.isActivityOpen.value = res.data != null && res.data.pcStart == true;
        console.log(Data.isActivityOpen.value)
        showWinningList()
      }
    })
    .catch((error) => {
      console.log('接口调用出错:', error)
    })

}

function logoutClick() {
  logoutVisible.value = false
  ElMessage({
    type: 'success',
    message: '退出登录成功'
  })
  Utill.outLoading()
}

function showLoginDialog() {
  let dialogData = {
    dialogType: 'login',
    show: true,
    dialogTitle: ''
  }
  console.log(dialogData)
  emitter.emit('show-appDialog', dialogData)
}

function showWinningList() {
  //特殊活动未结束，不展示结果
  if (Data.isActivityOpen.value) {
    isShowResult.value = false
    return
  }

  HTTP.getWinningList()
    .then((res) => {
      console.log(res)
      if (res.code == 200) {
        console.log(res)
        if (res.data == null || res.data.length == 0) {
          isShowResult.value = false
        } else {
          isShowResult.value = true
        }

      }
    })
}


function showSetDialog() {
  let dialogData = {
    dialogType: 'experience',
    show: true,
    dialogTitle: '修改设置'
  }
  console.log(dialogData)
  emitter.emit('show-appDialog', dialogData)
}

function resourceLink() {
  window.open('https://suyang.org.cn/', '_blank');
}

const currUserBookId = ref<any>(null)
function addBook() {

}

function handleChange() {
  console.log(Data.currUserBook.value)
  console.log(currUserBookId.value)
}

</script>

<template>

  <div class="header-ctr" :class="Data.isLogin.value == false ? 'null-header-ctr' : ''">
    <div class="logo-ctr">
      <img src="@/assets/xh.png" alt="Logo" class="logo-img" />
      <div class="title">核心素养教学活动与作业设计Ai生成平台 </div>
    </div>
    <div class="right-ctr">
      <el-button class="resource-link" v-if="Data.isLogin.value" @click="resourceLink">
        <img src="@/assets/zky/resource-icon.png" alt="" />
        资源平台
      </el-button>
      <div v-if="Data.isLogin.value">
        <el-select v-model="Data.currUserBook.value" value-key="id" placeholder="请选择图书" popper-class="custom-header"
          style="width: 240px" @change="handleChange" :disabled="route.name != 'knowledge'">
          <template #header>
            <el-button type="primary" v-if="Data.isLogin.value" @click.stop="Utill.showBookDialog(true)">
              新增图书（原用户）
            </el-button>
          </template>
          <el-option v-for="item in Data.userBook.value" :key="item.id" :label="item.bookName" :value="item" />
        </el-select>
      </div>
      <div class="user-ctr">
        <div class="user-name" v-if="Data.isLogin.value">
          {{ Data.userInfo.value?.nickname ? Data.userInfo.value?.nickname : '微信用户' }}
        </div>
        <el-popover placement="bottom" :width="228" trigger="hover" v-if="Data.isLogin.value"
          popper-class="head-popover">
          <template #reference>
            <div class="user-avatar">
              <img :src="Data.userInfo.value?.headimgurl
    ? Data.userInfo.value?.headimgurl
    : 'https://static.yipigai.cn/avatar.png'
    " alt="User Avatar" class="user-img" />
            </div>
          </template>
          <template #default>
            <div class="user-info-ctr">
              <img :src="Data.userInfo.value?.headimgurl
    ? Data.userInfo.value?.headimgurl
    : 'https://static.yipigai.cn/avatar.png'
    " alt="User Avatar" class="info-img" />
              <div>
                <p class="info-name">
                  {{ Data.userInfo.value?.nickname ? Data.userInfo.value?.nickname : '微信用户' }}
                </p>
                <p class="info-id">
                  用户ID：{{ Data.userInfo.value?.id ? Data.userInfo.value?.id : '' }}
                </p>
              </div>
            </div>
            <div class="vip-info" v-if="Data.lv.value != 0 && Data.currUserBook.value.expirationDate">
              <p class="vip-title">平台使用期限</p>
              <p class="vip-time">
                有效期至：{{ Data.currUserBook.value?.expirationDate ? Data.currUserBook.value?.expirationDate : '' }}
              </p>
            </div>
            <div class="vip-info new-user-count" v-if="Data.lv.value == 0">
              <p class="vip-title">
                暂无使用权限
                <!-- 剩余次数：{{ Data.lastCanCountByUser.value ? Data.lastCanCountByUser.value : 0 }}次 -->
              </p>
            </div>
            <div class="set-entrance" @click="showSetDialog"
              v-if='Data.currUserBook.value && !Data.currUserBook.value.isUpdate'>
              <p>修改设置<span class="set-tip">（仅可修改一次）</span></p>
              <div class="link-btn">
                <img src="@/assets/vip/order-arrow.png" alt="">
              </div>
            </div>
            <div class="logout-btn" @click="logoutVisible = true">退出登录</div>
          </template>
        </el-popover>
      </div>
      <div class="user-ctr" v-if="!Data.isLogin.value">
        <el-button @click="showLoginDialog" class="login-btn" type="primary">登录</el-button>
      </div>
    </div>
  </div>
  <div class="logout-dialog">
    <el-dialog v-model="logoutVisible" title="退出登录" width="380" :show-close="false">
      <el-icon class="logout-icon">
        <WarningFilled />
      </el-icon>
      <p>确认退出登录吗?</p>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="logoutVisible = false" class="cancel-btn">取消</el-button>
          <el-button type="primary" @click="logoutClick" class="ok-btn"> 确认 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.header-ctr {
  width: 100%;
  height: 60px;
  // background: #fff;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #DCDFE6;
}

// .null-header-ctr {
//   background: linear-gradient(90deg, #edf1ff 0%, rgba(245, 247, 251, 0.2) 100%) !important;
// }

.logo-ctr {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 27px;
  margin-left: 34px;
  margin-right: 12px;
}

.title {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;

  color: #040a39;
}

.right-ctr {
  display: flex;
  align-items: center;
  margin-right: 24px;
}

.user-ctr {
  display: flex;
  align-items: center;
  margin-left: 40px;
}

.wx-ctr {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: #F95946;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.act-ctr {
  margin-left: 46px;
  width: 101px;
  height: 25px;
  background: linear-gradient(102deg, #AC46DF 9%, #3C3FE5 97%);
  border-radius: 46px;
  color: #FFFFFF;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.act-ctr-img {
  position: absolute;
  transition: opacity 0.5s;
}

.act-ctr:hover {
  cursor: pointer;
}

.act-title {
  margin-left: 27px;
  margin-top: 2px;
}

.wx-ctr:hover {
  cursor: pointer;
}

.qrcode-img-ctr {
  margin-bottom: 12px;
  width: 120px;
  height: 120px;
}

.wx-qrcode-img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  opacity: 1;
  border: 1px solid #eaeaea;
}

.wx-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.wx-tip {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #718096;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #1d2129;
  margin-left: 8px;
}

.user-avatar {
  margin-left: 8px;
  position: relative;
  width: 35px;
  height: 32px;
  text-align: center;
}

.user-img {
  width: 32px;
  height: 32px;
  /*border: 1px solid #e5e6eb;*/
  border-radius: 50%;
}

.vip-img {
  width: 75px;
  height: 24px;
  margin-right: 8px;
}

.user-info-ctr {
  display: flex;
  align-items: center;
  padding-top: 4px;
}

.info-img {
  margin-right: 8px;
  width: 32px;
  height: 32px;
  border: 1px solid #e5e6eb;
  border-radius: 50%;
}

.info-name {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: #1d2129;
}

.info-id {
  font-size: 12px;
  font-weight: normal;
  line-height: 22px;
  color: #909399;
}

.vip-info {
  background: url('@/assets/vip-bg.png') no-repeat;
  background-size: cover;
  width: 196px;
  height: 63px;
  margin-top: 10px;
  padding-left: 14px;
  padding-top: 8px;
  padding-bottom: 7px;
}

.new-user-count {
  text-align: center;
  padding: 20px 0 0;
}

.vip-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #fc7709;
}

.vip-time {
  font-size: 12px;
  font-weight: normal;
  line-height: 22px;
  color: #909399;
  margin-top: 4px;
}

.logout-btn {
  width: 196px;
  height: 32px;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1d2129;
  border-radius: 43px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  margin: 16px 0 0;
}

.logout-btn:hover {
  background: #fff1ef;
  box-sizing: border-box;
  border: 1px solid #F95946;
  cursor: pointer;
  color: #F95946;
}

.logout-dialog {
  :deep(.el-dialog) {
    border-radius: 16px;
    box-shadow: 0px 4px 10px 0px rgba(158, 172, 229, 0.3);
    padding: 20px 20px 11px;

    .el-dialog__header {
      font-size: 18px;
      font-weight: bold;
      line-height: 26px;
      align-items: center;
      font-variation-settings: 'wght' 600;
      color: #040a39;
    }

    .el-dialog__body {
      font-size: 14px;
      font-weight: normal;
      display: flex;
      align-items: center;
      line-height: 22px;
    }
  }
}

.dialog-footer {
  :deep(.el-button) {
    width: 60px;
    height: 32px;
    border-radius: 92px;
    font-size: 14px;
    font-weight: 500;
  }
}

.cancel-btn {
  background: #fff1ef;
  border: none !important;
}

.cancel-btn:hover {
  background: #fdcfcb;
  border: none !important;
}

.ok-btn {
  margin-left: 8px;
  border: none !important;
}

.logout-icon {
  width: 16px;
  height: 16px;
  margin-right: 9px;
  color: #e6a23c;
  font-size: 16px;
}

.login-btn:hover {
  background: #ea422e
}

.login-btn {
  width: 80px;
  height: 36px;
  border-radius: 32px;
  color: #ffffff;
  border: none !important;
  background: #F95946;
}


.vip-btn {
  width: 91px;
  height: 24px;
  background: linear-gradient(90deg, #FDAB68 0%, #FC7303 100%);
  border-radius: 256px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #FFFFFF;
  display: flex;
  cursor: pointer;

}


.vip-btn:hover {
  background: #FC7506;
  border: none !important;
}

.vip-btn img {
  width: 16px;
  height: 16px;
  margin: 4px 3px 4px 8px;
}

.avatar-ctr {
  position: relative;
}

.vip-border {
  border: 1px solid #FC7406;
}

.vip-border-expire {
  border: 1px solid #CBCBCB;
}

.vip-avatar {
  position: absolute;
  bottom: -7px;
  right: 0;
  width: 35px;
  height: 14px;
}

.avatar-ctr {
  position: relative;
  width: 32px;
  height: 32px;
}

.set-entrance {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: #040A39;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  cursor: pointer;
}

.set-tip {
  font-weight: 400;
  font-size: 12px;
  color: #B9B9B9
}

.link-btn {
  width: 30px;
  height: 22px;
  padding: 4px 0 4px 16px;
}

.link-btn img {
  width: 14px;
  height: 14px;
}

.resource-link {
  width: 100px;
  height: 32px;
  border-radius: 8px;
  opacity: 1;
  background: #fff1ef;
  border: none;
  color: #F95946;
  font-size: 14px;
  font-weight: normal;
  padding: 0 10px;
  margin-right: 40px;
}

.resource-link:hover {
  width: 100px;
  height: 32px;
  border-radius: 8px;
  opacity: 1;
  background: #fdcfcb;
  border: none;
  color: #F95946;
  font-size: 14px;
  font-weight: normal;
}

.resource-link img {
  width: 18px;
  height: 18px;
  margin-right: 6px;

}
</style>
<style lang="scss">
.head-popover {
  --el-popover-border-radius: 16px !important;
  box-shadow: 0px 4px 10px 0px rgba(158, 172, 229, 0.3) !important;
  border: none !important;
  padding: 16px !important;
  top: 58px !important;
  min-width: 140px !important;
}

.qrcode-popover {
  --el-popover-border-radius: 16px !important;
  box-shadow: 0px 4px 10px 0px rgba(158, 172, 229, 0.3) !important;
  border: none !important;
  padding: 12px !important;
  top: 54px !important;
  min-width: 144px !important;
}
</style>
